// extracted by mini-css-extract-plugin
module.exports = {"points":"AnygiftPoints_points___1Crv","point":"AnygiftPoints_point__0UIE_","wrap":"AnygiftPoints_wrap__yh7Ag","pointTitle":"AnygiftPoints_pointTitle__aULvQ"};